/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=77413f32&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77413f32",
  null
  
)

export default component.exports